<div class="app-container">
  @if (showNavbar) {
    <app-navbar></app-navbar>
  }
  <main class="main" id="main-content">
    <router-outlet />
  </main>
</div>
